import PropTypes from 'prop-types';

const FormField = ({ fieldKey, input, value, handleInputChange, error, estado}) => {
  const { label, name, placeholder, type, id, disable, readOnly = false, defaultValue , hidden} = input;
  
  if (hidden) return null;
  const fieldClass = disable ? 'disabledField' : (error ? 'inputError' : '');
  const inputStyle = estado ? { backgroundColor: "lightgray" } : { backgroundColor: "white" };
  const resolvedValue = value !== undefined ? value : defaultValue || "";

  return (
    <div className="formInput">
      <label htmlFor={name}>{label}</label>
      {type === "file" ? (
        <input
          id={id}
          key={fieldKey}
          type="file"
          name={name}
          onChange={handleInputChange}
          disabled={disable}
          readOnly={readOnly}
          style={inputStyle}
        />
      ) : type === 'select' ? (
        <select
          id={id}
          key={fieldKey}
          name={name}
          onChange={handleInputChange}
          value={resolvedValue}
          className={fieldClass}
          disabled={disable}
          style={inputStyle}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {input.options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          id={id}
          key={fieldKey}
          name={name}
          placeholder={placeholder}
          onChange={handleInputChange}
          value={resolvedValue}
          className={fieldClass}
          disabled={disable}
          readOnly={readOnly}
          style={inputStyle}
          height="100px"
        />
      ) : type === 'float' ? (
        <input
          id={id}
          key={fieldKey}
          type="number"
          name={name}
          placeholder={placeholder}
          onChange={handleInputChange}
          value={resolvedValue}
          className={fieldClass}
          disabled={disable}
          style={inputStyle}
          step="0.01" // Permitir decimales con dos dígitos
          min="0" // Evitar valores negativos si es necesario
        />
      ) : (
        <input
          id={id}
          key={fieldKey}
          type={type}
          name={name}
          placeholder={placeholder}
          onChange={handleInputChange}
          value={resolvedValue}
          className={fieldClass}
          disabled={disable}
          style={inputStyle}
        />
      )}
      {error && <span className="error">{error}</span>}
    </div>
  );
};

// Añadir validación de propiedades con PropTypes
FormField.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })), // Asegura que las opciones de select sean válidas
    disable: PropTypes.bool, // Añadir validación para 'disable'
  }).isRequired,
  value: PropTypes.any,
  handleInputChange: PropTypes.func,
  error: PropTypes.string,
  estado: PropTypes.bool,
  hidden: PropTypes.bool, // Nueva propiedad 'hidden'
};

export default FormField;
